import styled from "styled-components";

export const AnnouncementSection = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  @media only screen and (min-width: 1400px) {
    width: 62%;
  }
  @media only screen and (max-width: 1400px) {
    width: 70%;
  }
  @media only screen and (max-width: 968px) {
    width: 70%;
    padding-top: 20px;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;
export const AnnouncementContainer = styled.div`
	width: 100%;
	background: ${p => p.theme.COLORS.drawerBgColor};
	margin-top: 30px;
`
